import script from "./TextOnlyViews1.vue?vue&type=script&setup=true&lang=js"
export * from "./TextOnlyViews1.vue?vue&type=script&setup=true&lang=js"

import "./TextOnlyViews1.vue?vue&type=style&index=0&id=23b698dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b698dd"]])

export default __exports__